import { defineMessages } from 'dibs-react-intl';

export default defineMessages({
    email: {
        defaultMessage: 'Please enter a valid email address.',
        id: 'du.dibs-registration-validator.email',
    },
    emailMax: {
        defaultMessage: 'Please enter a maximum of 256 characters',
        id: 'du.dibs-registration-validator.emailMax',
    },
    password: {
        defaultMessage: 'Please enter at least 5 characters.',
        id: 'du.dibs-registration-validator.passwordRequired',
    },
    required: {
        defaultMessage: 'Required field',
        id: 'du.dibs-registration-validator.required',
    },
    invalidEmail: {
        defaultMessage: 'Please enter a valid email address',
        id: 'du.dibs-registration-validator.invalidEmail',
    },
    passwordMin: {
        defaultMessage: 'Please enter at least 5 characters.',
        id: 'du.dibs-registration-validator.passwordMin',
    },
    passwordMax: {
        defaultMessage: 'Please enter a maximum of 128 characters',
        id: 'du.dibs-registration-validator.passwordMax',
    },
});
